var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-page',[_c('iframe',{staticClass:"absolute",attrs:{"src":"ClimbICP_Website%20Terms%20and%20Conditions_17%20June%202019.pdf"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }